<template>
  <input
    ref="inputRef"
    type="text"
    @blur="blur"
    @input="input"
    class="input"
  />
</template>

<script>
import { onMounted, nextTick, watch } from 'vue';
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  props: {
    modelValue: Number,
    options: Object,
    blur: Function,
    input: Function,
    disableAutoFocus: Boolean,
  },
  setup(props) {
    const { inputRef, setValue, setOptions } = useCurrencyInput(props.options);
    watch(
      () => props.options,
      (options) => {
        setOptions(options)
      }
    )

    onMounted(() => {
      nextTick(() => {
        if (!props.disableAutoFocus) {
          if (inputRef) inputRef.value.focus()
        }
      });
    })

    return { inputRef, setValue }
  },
}
</script>


<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.input {
  border-radius: 6px;
  border: 1px solid $colorD30;
  transition: 0.3s;
  color: $colorN80;
  width: 100%;
  padding: 10.75px 12px;
  font-size: 12px;
  &:hover {
    border-color: $colorD50;
  }

  &:focus-visible {
    border: 1px solid $colorB50;
    outline: 3px solid $colorB10;
  }

  &[type="number"] {
    position: relative;

    &::-webkit-inner-spin-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 8px;
      width: 8px;
      height: 16px;
    }
  }
}

</style>